import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"

import Button from "components/ui/button"
import skuColor, { mapMetalClass } from "helpers/product/sku-colors"
import { useNavigation } from "helpers/use-navigation"
import { cn } from "styles/utils"

const LookColor = ({
  active,
  handleClick,
  look,
  swatchClassName,
  ...props
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })
  const vermeil = ["sstkyp", "sskyp", "vermy"].includes(
    look.replace(/[0-9]/g, "").toLowerCase()
  )
  const metalName = skuColor(look)

  return (
    <Button
      aria-label={metalName}
      aria-selected={active}
      className={cn(
        "bg-grey-20 mx-px size-16 rounded-full",
        mapMetalClass(look),
        active && "ring-grey-35 border-2 border-white ring",
        vermeil && "border-sku-ky bg-grey-20 border-4",
        swatchClassName
      )}
      onClick={handleClick}
      role="option"
      tabIndex={active ? 0 : -1}
      title={metalName}
      {...props}
      {...keyboardProps}
    />
  )
}

LookColor.propTypes = {
  active: PropTypes.bool,
  handleClick: PropTypes.func,
  look: PropTypes.string,
  swatchClassName: PropTypes.string,
}

const LooksSelector = ({
  className,
  looks,
  product,
  selectedLook,
  swatchClassName,
  updateLook,
}) => {
  if (Object.keys(looks || {}).length === 0) {
    return <div className={cn("min-h-34 pb-10 pt-8", className)} />
  }

  return (
    <FocusScope>
      <div
        aria-label="Metal options"
        aria-orientation="horizontal"
        className={cn(
          "min-h-34 flex justify-center gap-6 pb-10 pt-8",
          className
        )}
        role="listbox"
      >
        {Object.keys(looks).map((look) => (
          <LookColor
            active={selectedLook === look}
            handleClick={(e) => {
              e.preventDefault()
              updateLook(look)
            }}
            key={`look-${look}-${product.style_code}`}
            look={look}
            swatchClassName={swatchClassName}
          />
        ))}
      </div>
    </FocusScope>
  )
}

LooksSelector.propTypes = {
  className: PropTypes.string,
  looks: PropTypes.object.isRequired,
  product: PropTypes.object,
  selectedLook: PropTypes.string,
  swatchClassName: PropTypes.string,
  updateLook: PropTypes.func,
}

export default LooksSelector
